/**
 * Centered modal with fade transition and a close button.
 */
import React from "react";
import { Icon } from "@iconify/react";
import { Backdrop, Box, Modal, Fade } from "@mui/material";
import PropTypes from "prop-types";

import { VButton } from "form";

/**
 * Overlay dialog that renders children in a centered, scrollable panel.
 *
 * @param {{ open?: boolean, setOpen?: Function, children?: React.ReactNode, className?: string }} props
 */
const BModal = (props) => {
  const { open, setOpen, children, className, ...rest } = props;

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={() => setOpen(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        className="overflow-auto"
        {...rest}
      >
        <Fade in={open}>
          <Box className={`absolute inset-1/2 v-focus-none v-bg-body rounded shadow-xl overflow-auto relative v-light-scrollbar v-main-modal ${className}`} sx={{ width: "fit-content", height: "fit-content", transform: "translate(-50%, -50%)", maxHeight: "90%", maxWidth: "90%" }}>
            <VButton iconOnly className="absolute top-0 right-0 z-10" onClick={() => setOpen(false)}>
              <Icon icon="carbon:close-filled" />
            </VButton>
            {children}
          </Box>
        </Fade>
      </Modal>
    </div>
  );
};

BModal.defaultProps = {
  open: false,
  setOpen: () => {},
  children: {},
  className: "",
};

BModal.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  children: PropTypes.any,
  className: PropTypes.string.isRequired,
};

export default BModal;
